import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/gossip';
import FaqAccordion from '@/components/feature/FaqAccordion';

export default function FaqPreview() {
  return (
    <section className="mx-auto w-full max-w-4xl px-4 py-14 md:px-6 md:py-20">
      <div className="text-center">
        <span className="text-xs font-medium tracking-[0.25em] text-primary-600">FAQ</span>
        <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">吃瓜前先看这几条</h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-7 text-foreground-600">
          关于内容方向、加入社群与分享码的常见疑问，整理在这里，方便你快速了解。
        </p>
      </div>

      <div className="mt-10">
        <FaqAccordion items={faqs.slice(0, 4)} />
      </div>

      <div className="mt-6 text-center">
        <Link
          to="/faq"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          查看全部问题
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}